import React from 'react'
import { ModalFooter as ReactStrapModalFooter, ModalFooterProps as ReactStrapModalFooterProps } from 'reactstrap'

export const ModalFooter = (props: ReactStrapModalFooterProps) => <ReactStrapModalFooter {...props} />
